import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { DndProvider, getBackendOptions, MultiBackend } from '@minoru/react-dnd-treeview'
import { layoutStore } from 'shared/ui'
import {
  type IDropOptions,
  type IInboxTreeCombine,
  type INodeModel,
  TreeRootInboxes,
} from 'entities/Inbox'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import { actionTeamsFavoriteDragDrop } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/TeamsFavoriteDragDrop'
import { actionMoveToDragDrop } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/MoveToDragDrop'
import { actionReorderFavoritesDragDrop } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/ReorderFavoritesDragDrop'
import { MenuSectionSmartViewsTree } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/MenuSectionSmartViewsTree'
import { MenuFavoritesInboxes } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/MenuFavoriteInboxes/MenuFavoritesInboxes.tsx'
import { MenuSimpleInboxes } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/MenuSimpleInboxes/MenuSimpleInboxes.tsx'
import { RequestAccessItem } from './RequestAccessItem/RequestAccessItem'
import { MenuQuickFilters } from './MenuQuickFilters/MenuQuickFilters'
import styles from './styles.module.scss'

export const ConversationMenuInboxes = observer(() => {
  const store = useConversationMenuContext()
  const { usersStore } = useEntitiesContext()
  const { pageLayoutStore } = store
  const isShouldRequestAccess = !!usersStore.user?.isShouldRequestAccess

  const handleDrop = async (
    items: INodeModel<IInboxTreeCombine>[],
    options: IDropOptions<IInboxTreeCombine>,
    dropRoot: TreeRootInboxes
  ) => {
    const { dragSource } = options
    const dragId = dragSource?.id?.toString()
    const dropTargetStr = options.dropTargetId?.toString() ?? ''

    if (
      dragId?.startsWith(dropRoot) &&
      dropTargetStr &&
      !dropTargetStr.startsWith(dropRoot.toString())
    ) {
      return
    }

    await actionTeamsFavoriteDragDrop(options, dropRoot, store)
    await actionMoveToDragDrop(options, dropRoot, store)
    await actionReorderFavoritesDragDrop(items, options, dropRoot, store)
  }

  useEffect(() => {
    if (isShouldRequestAccess) {
      store.setLoadingUser(false)
    }
  }, [isShouldRequestAccess])

  if (isShouldRequestAccess) return <RequestAccessItem />

  const onClickItemTree = () => {
    if (layoutStore.isMediumView) {
      pageLayoutStore.handleChangeCollapse(true)
    }
  }

  return (
    <DndProvider backend={MultiBackend} options={getBackendOptions()}>
      <MenuQuickFilters />

      <div className={styles.wrap}>
        <MenuFavoritesInboxes onDrop={handleDrop} onClickItem={onClickItemTree} />
        <MenuSectionSmartViewsTree root={TreeRootInboxes.SMART_VIEW} handleDrop={handleDrop} />
        <MenuSimpleInboxes onDrop={handleDrop} onClickItem={onClickItemTree} />
      </div>
    </DndProvider>
  )
})
